import "@babel/polyfill";
import 'expose-loader?$!jquery';
import 'expose-loader?jQuery!jquery';


import { UnifyLoader } from './integration/unifyloader';
window.UnifyLoader = UnifyLoader;
